import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33baafed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SendersListItem" }
const _hoisted_2 = { class: "SendersListItem__title" }
const _hoisted_3 = { class: "mt-2 text-sm" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-user mr-2" }, null, -1))
const _hoisted_6 = { class: "block" }
const _hoisted_7 = { class: "flex items-center mt-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-mobile mr-3" }, null, -1))
const _hoisted_9 = { class: "block" }
const _hoisted_10 = { class: "flex items-center mt-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-map-marker-alt mr-3" }, null, -1))
const _hoisted_12 = { class: "block" }
const _hoisted_13 = { class: "flex items-center justify-between mt-3" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.item.fullName), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.item.user.fullName), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.item.phoneNumber || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.item.fullAddress || 'Не указан'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_cheap, {
          class: _normalizeClass(["small", { green: _ctx.isSenderHaveCoordinates, red: !_ctx.isSenderHaveCoordinates }])
        }, {
          default: _withCtx(() => [
            (_ctx.isSenderHaveCoordinates)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_15,
                  _createTextVNode(" Координаты установлены ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_16,
                  _createTextVNode(" Без координат ")
                ], 64))
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_the_button, {
          class: "primary text small mr-2",
          disabled: _ctx.state.is_deleting || _ctx.disabled,
          onClick: _ctx.emitUpdate
        }, {
          default: _withCtx(() => [
            _hoisted_18,
            _createTextVNode(" Редактировать ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_the_button, {
          class: "red text small mr-2",
          loading: _ctx.state.is_deleting,
          disabled: _ctx.disabled,
          onClick: _ctx.emitDelete
        }, {
          default: _withCtx(() => [
            _hoisted_19,
            _createTextVNode(" Удалить ")
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary text small",
          disabled: _ctx.state.is_deleting || _ctx.disabled,
          onClick: _ctx.emitSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_20,
            _createTextVNode(" Выбрать ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ]))
}